import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { WhoWeAreModule } from '../components/WhoWeAreModule';
export function WhatWeDoPage() {
  return <>
      <PageHero label="About Us" title="What We Do" subtitle="We design, manufacture, and supply specialist equipment for high-risk operational environments." data-id="element-1485" />
      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'What We Do'
    }]} data-id="element-1486" />

      {/* Reusing the WhoWeAreModule as it contains relevant overview content */}
      <WhoWeAreModule data-id="element-1487" />
    </>;
}